import * as React from "react";
import type { SVGProps } from "react";
const SvgBusLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.791 17H23a1 1 0 0 0 1-1V9a3 3 0 0 0-3-3H4a4 4 0 0 0-4 4v6a1 1 0 0 0 1 1h1.209a2.5 2.5 0 0 0 4.591-.02q.098.02.2.02h9q.102 0 .2-.02a2.5 2.5 0 0 0 4.591.02M2 13v2h.209a2.5 2.5 0 0 1 4.591.02Q6.898 15 7 15v-3H5.41l-.41.41a2 2 0 0 1-1.41.59zm5-3H5.41a2 2 0 0 0-1.41.59l-.41.41H2v-1a2 2 0 0 1 2-2h3zm2 2v3h2v-3zm2-2H9V8h2zm2 0V8h8a1 1 0 0 1 1 1v1zm0 2h9v3h-1.209a2.502 2.502 0 0 0-4.059-.768 2.5 2.5 0 0 0-.532.788A1 1 0 0 0 16 15h-3zm6 4.001V16a.5.5 0 1 0 0 .001M4.5 15.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusLeft;
